import { Component, OnInit } from '@angular/core';
import { StreappEvent } from 'src/app/models/streappevent.model';
import { AuthService } from 'src/app/services/auth.service';
import { StreappEventsService } from 'src/app/services/streapp-events.service';

@Component({
    selector: 'my-streapps',
    templateUrl: './my-streapps.component.html',
    styleUrls: ['./my-streapps.component.scss'],
    standalone: false
})
export class MyStreAppsComponent implements OnInit {
  myEvents: Array<StreappEvent> = [];
  displayAds: boolean = true;

  loading: boolean = true;
  errorText: string;

  constructor(
    private readonly authService: AuthService,
    private readonly streappService: StreappEventsService
  ) {}

  ngOnInit(): void {
    this.loadStreappEvents();

    this.displayAds = !this.authService.isAdFree;
  }
 
  pushGoogleAds() {
    if(!this.displayAds) return;

    setTimeout(() => {
      try {
        this.myEvents.forEach((event: StreappEvent, index) => {
          if (index % 5 === 0 && index > 0) {
            (window["adsbygoogle"] = window["adsbygoogle"] || []).push({});
          }
        });
      } catch (e) {
        console.error("ads", e);
      }
    }, 900);
  }

  loadStreappEvents(): void {
    this.streappService
      .getMyEvents(this.authService.authorizationHeaderValue)
      .then((data) => {
        this.myEvents = data;
        this.pushGoogleAds();
      })
      .catch((error) => {
        this.errorText = error;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
